import {createStore, combineReducers, applyMiddleware} from "redux"
import {reducer as user} from "./user/reducer"
import {reducer as app} from "./app/reducer"
import {reducer as ride} from "./ride/reducer"
import {reducer as billing} from "./billing/reducer"
import {reducer as updater} from "./swupdater/reducer"
import map from "components/Map/reducer"
import thunk from "redux-thunk"
import {createLogger} from "redux-logger"
import callAPIMiddleware from "./callAPIMiddleware"
import {asyncDispatchMiddleware} from "./asyncDispatchMiddleware"

const logger = createLogger()

const rootReducer = combineReducers({user, app, map, ride, billing, updater})
const store = createStore(
    rootReducer,
    applyMiddleware(
        thunk,
        asyncDispatchMiddleware,
        callAPIMiddleware,
        // logger
        ))

export default store
